export default __webpack_public_path__ + "static/media/BalanceTransfer.53257bb9.svg";